import React from 'react';
import styles from './UnitAmenities.module.css';
import { FaCheckCircle } from 'react-icons/fa';

const UnitAmenities = ({ features }) => {
  return (
    <div className={styles.amenitiesContainer}>
      <h2 className={styles.title}>Amenities</h2>
      <div className={styles.featuresGrid}>
        {features.map((feature, idx) => (
          <div key={idx} className={styles.featureItem}>
            <span className={styles.icon}>✔️</span>
            <span>{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnitAmenities;
